import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const LOOSE_ARTICLES_QUERY = gql`
  query looseArticles($documentVersion: DocumentVersionInput!, $id: String!,
  $searchTerm: String!, $salesArea: String!, $paging: PageInput!) {
    products {
      count
      category(documentVersion: $documentVersion, id: $id, salesArea: $salesArea,
      paging: $paging, path: "", querystring: $searchTerm) {
        products {
          hasMore
          pageInfo {
            currentPage
          }
          items {
            id: name
            name
            description
            imageId
            properties {
              name
              value
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class LooseArticlesQuery extends Query<RootQuery> {
  document = LOOSE_ARTICLES_QUERY;
}
